import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Flex } from 'foundations-components/components/Flex';
import FolderTree from 'framework-listing-lib/internal/Folders/components/FolderTree';
import RecentFolders from 'framework-listing-lib/internal/Folders/components/RecentFolders';
import { FOLDER_PROPERTIES } from 'framework-listing-lib/internal/Folders/constants/folders';
import useFetchRecentFolders from 'framework-listing-lib/internal/Folders/hooks/useFetchRecentFolders';
import useCrmObjectTypeName from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import { useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function TabContent({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    blockSize: "300px",
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: "100%",
      children: children
    })
  });
}
export default function ListingLibMoveAssetsModalBody({
  assetCount,
  assetName,
  currentFolderId,
  currentFolderName,
  error,
  onClickRecentFolder,
  onOpenChange,
  openFoldersMap,
  selectedAssetFolderId,
  selectedObjectOrObjects,
  selectedObjectsCount
}) {
  const isFoldersMode = useIsFoldersMode();
  const {
    objectTypeNamePlural,
    objectTypeNameSingular
  } = useCrmObjectTypeName();
  const {
    recentFolders,
    loading: loadingRecentFolders
  } = useFetchRecentFolders();
  const assetsList = useMemo(() => Array.isArray(selectedObjectOrObjects) ? selectedObjectOrObjects : [selectedObjectOrObjects], [selectedObjectOrObjects]);
  const cannotDisplayAssetList = useMemo(() => Boolean(selectedObjectsCount && selectedObjectsCount > 1 && !(Array.isArray(selectedObjectOrObjects) ? selectedObjectOrObjects.length : selectedObjectOrObjects)), [selectedObjectOrObjects, selectedObjectsCount]);
  const folderList = /*#__PURE__*/_jsx(TabContent, {
    children: /*#__PURE__*/_jsx(FolderTree, {
      currentFolderId: currentFolderId,
      onClick: onOpenChange,
      openFoldersMap: openFoldersMap,
      variant: "modal",
      selectedAssetFolderId: isFoldersMode ? selectedAssetFolderId : undefined,
      selectedAssetCount: assetCount
    })
  });
  if (loadingRecentFolders) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: currentFolderName ? 'frameworkListingLib.folders.moveAssetsModal.paragraph' : 'frameworkListingLib.folders.moveAssetsModal.paragraphNoFolderName',
        options: {
          assetName: /*#__PURE__*/_jsx("strong", {
            children: `"${assetName}"`
          }),
          assetCount: /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(List, {
              styled: true,
              paddingInlineStart: "400",
              marginBlockEnd: "0",
              children: assetsList.map(crmFolder => /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx("span", {
                  children: getPropertyValue(crmFolder, FOLDER_PROPERTIES.name)
                })
              }, crmFolder.objectId))
            }),
            disabled: cannotDisplayAssetList,
            children: /*#__PURE__*/_jsx(Text, {
              as: "span",
              typography: "body-125",
              fontStyle: !cannotDisplayAssetList ? 'italic' : undefined,
              textDecoration: !cannotDisplayAssetList ? 'underline' : undefined,
              children: `${assetCount}`
            })
          }),
          count: assetCount,
          objectTypeName: objectTypeNameSingular,
          objectTypeNamePlural,
          folderName: /*#__PURE__*/_jsx("strong", {
            children: `"${currentFolderName}"`
          })
        }
      })
    }), error && /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.folders.moveAssetsModal.error"
      })
    }), recentFolders.length > 0 ? /*#__PURE__*/_jsxs(UITabs, {
      defaultSelected: "1",
      children: [/*#__PURE__*/_jsx(UITab, {
        tabId: "1",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.folders.moveAssetsModal.tabs.suggested"
        }),
        children: /*#__PURE__*/_jsx(TabContent, {
          children: /*#__PURE__*/_jsx(RecentFolders, {
            currentFolderId: currentFolderId,
            onClickFolder: onClickRecentFolder,
            selectedAssetFolderId: isFoldersMode ? selectedAssetFolderId : undefined,
            selectedAssetCount: assetCount
          })
        })
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: "2",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.folders.moveAssetsModal.tabs.allFolders"
        }),
        children: folderList
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: folderList
    })]
  });
}